export class WildMeterEvents {
	public static readonly WIN_METER_WILDS_ANIMATIONS_FINISHED: string = 'WildMeterEvents::WIN_METER_WILDS_ANIMATIONS_FINISHED';
	public static readonly WIN_METER_EXIT_WIN_ANIMATION_STARTED: string = 'WildMeterEvents::WIN_METER_EXIT_WIN_ANIMATION_STARTED';
	public static readonly WIN_METER_EXIT_WIN_ANIMATION_FINISHED: string = 'WildMeterEvents::WIN_METER_EXIT_WIN_ANIMATION_FINISHED';
	public static readonly ADD_WILD_COIN_TO_REELS: string = 'WildMeterEvents::ADD_WILD_COIN_TO_REELS';
	public static readonly SEND_COIN_TO_METER: string = 'WildMeterEvents::SEND_COIN_TO_METER';
	public static readonly COIN_HIT_METER: string = 'WildMeterEvents::COIN_HIT_METER';
	public static readonly MULTIPLIER_UDPATE: string = 'WildMeterEvents::MULTIPLIER_UDPATE';
	public static readonly INDICATOR_LIT: string = 'WildMeterEvents::INDICATOR_LIT';

}



// WEBPACK FOOTER //
// ./src/wildmeter/WildMeterEvents.ts